// extracted by mini-css-extract-plugin
export default {"servises":"ListServices_servises__GxVdK","wrp":"ListServices_wrp__YOFF1"};